import Model from "../model";

class BookingPaymentTransaction extends Model {
  constructor(object) {
    super();
    const { statusCode, titleTh, titleEn, detailTh, detailEn, buttonLink } =
      object || {};

    this.statusCode = statusCode;
    this.titleTh = titleTh;
    this.titleEn = titleEn;
    this.detailTh = detailTh;
    this.detailEn = detailEn;
    this.buttonLink = buttonLink;
  }
}

export default BookingPaymentTransaction;
